<template>
    <div class="tip-carousel">
        <carousel
            v-if="tips.length"
            autoplay
            reset-autoplay-on-nav
            :autoplay-hover-pause="false"
            :autoplay-timeout="6000"
            navigation-enabled
            pagination-enabled
            loop
            vertical-align
            :per-page="1"
            :pagination-size="25">
            <slide
                v-for="tip in tips"
                :key="tip.id">
                <div class="tip-carousel__content-tip">
                    <p class="tip-carousel__content-tip-heading">
                        {{ tip.heading }}
                    </p>
                    <p class="tip-carousel__content-tip-text">
                        {{ tip.text }}
                    </p>
                </div>
            </slide>
        </carousel>
    </div>
</template>

<script>
import Carousel from '@/common/carousel/carousel.vue';
import Slide from '@/common/carousel/slide.vue';

export default {
    name: 'TipCarousel',
    components: {
        Carousel,
        Slide,
    },
    props: {
        tips: {
            type: Array,
            required: true,
        },
    },
};
</script>

<style lang="less" scoped>
@import '@/voc/styles/voc.style.less';
.tip-carousel {
    &__content-tip {
        height: 260px;
        background-image: url('~@img/voc/tip-background.svg');
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        margin-top: 24px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-size: 16px;
    }

    &__content-tip-heading {
        font-weight: 600;
        margin: -40px 0px 0px 0px;
        width: 75%;
    }

    &__content-tip-text {
        color: var(--palette-gray-90);
        margin: 16px 0px 0px 0px;
        line-height: 1.5;
        width: 75%;
    }

    :deep(.VueCarousel-navigation-button) {
        display: none;
    }

    :deep(.VueCarousel-pagination) {
        margin: -12px 0px 0px 0px;
        z-index: 1000;
        position: relative;
    }

    :deep(.VueCarousel-dot) {
        border: none;
        margin: 3px;
        width: 10px;
        height: 10px;
        background-color: var(--palette-gray-40);

        &-container {
            margin: 0px 0px 8px 0px;
        }

        &--active {
            background-color: var(--palette-purple-80);
        }
    }
}
</style>
